import { createApp, reactive,provide,inject  } from 'vue'
import App from './App.vue'
import rem from'./common/js/rem.js'
import mqtt from'./common/js/mqtt.js'
import router from './router'
import axios from 'axios'
// import Vant from 'vant'
import {createState} from './store'
import 'vant/lib/index.css'
import './common/css/base.css'
import './common/iconfont/iconfont.css'
import less from 'less'
import { Collapse, CollapseItem,Tab, Tabs,NavBar,Swipe, SwipeItem,Search,List,Icon,Divider,Popup } from 'vant';

axios.defaults.baseURL = 'http://www.supershooter.cn:8095'
// axios.defaults.baseURL = 'http://192.168.24.93:56655'
const app = createApp(App)
app.config.globalProperties.$http =axios

app
.use(mqtt)
.use(router)
.use(less)
.use(Swipe)
.use(SwipeItem)
.use(List)
.use(Search)
.use(Icon)
.use(NavBar)
.use(Tab)
.use(Tabs)
.use(Collapse)
.use(CollapseItem)
.use(Divider )
.use(Popup  )
.mount('#app')
